module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Kf-Ld.b5f87902.png";